import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { tenantManagementApi } from "./tenant-api";

interface TenantManagementState {
  tenantManagement: ITenant[];
  selectedTenant?: ITenant;
  areTenantsLoading: boolean;
}

const initialState: TenantManagementState = {
  tenantManagement: [],
  selectedTenant: undefined,
  areTenantsLoading: false,
};

export const tenantManagementSlice = createSlice({
  name: "tenantManagement",
  initialState,
  reducers: {
    setTenantManagement: (
      state,
      { payload }: PayloadAction<TenantManagementState["tenantManagement"]>
    ) => {
      state.tenantManagement = payload;
      state.areTenantsLoading = false;
    },
    clearTenantManagement: (state) => {
      state.tenantManagement = [];
    },
    setSelectedTenant: (state, action: PayloadAction<ITenant | undefined>) => {
      state.selectedTenant = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      tenantManagementApi.endpoints.getAllTenants.matchPending,
      (state) => {
        state.areTenantsLoading = true;
      }
    );
  },
});

export const { setTenantManagement, clearTenantManagement, setSelectedTenant } =
  tenantManagementSlice.actions;
